declare global {
  interface Boolean {
    toString(): string;
    toNumber(): number;
  }
}

Boolean.prototype.toString = function(this: boolean): string {
  return this ? 'true' : 'false';
}

Boolean.prototype.toNumber = function(this: boolean): number {
  return this ? 1 : 0;
}

export { }
